import { render, staticRenderFns } from "./SeoLinks.vue?vue&type=template&id=e5a0ad20&"
import script from "./SeoLinks.vue?vue&type=script&lang=js&"
export * from "./SeoLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports